import { ReactNode } from 'react';
import { getConnectedUserRole } from '../utils';
import { Box, Text, Button } from '@mantine/core';
import { useCurrentUser } from "../hooks/useCurrentUser";

interface RoleProtectedRouteProps {
  children: ReactNode;
  allowedRoles: string[];
}

export const RoleProtectedRoute = ({ children, allowedRoles }: RoleProtectedRouteProps) => {
  const currentUser = useCurrentUser();
  const userRole = getConnectedUserRole(currentUser);
  
  // Check if user role is in the allowed roles list
  const hasAccess = allowedRoles.includes(userRole);
  
  if (!hasAccess) {
    return (
      <Box p="xl" ta="center">
        <Text size="xl" fw={600} mb="md">Access Denied</Text>
        <Text color="dimmed" mb="lg">
          You don't have permission to access this page. This page is only available for users with the following roles: {allowedRoles.join(', ')}.
        </Text>
        <Button onClick={() => window.history.back()}>
          Go Back
        </Button>
      </Box>
    );
  }
  
  return <>{children}</>;
};

